export default {
  loginPage: {
    coperation: 'DevUI Design Presented',
    loginWays: {
      account: 'Account Login',
      email: 'Email Login',
    },
    autoLogin: 'Remember me',
    forgetPassword: 'Forgot Password?',
    submit: 'Submit',
    userName: 'Username',
    password: 'Password',
    email: 'Email',
    noticeMessage: {
      summary: 'Login Failed',
      accountContent:
        'Please input correct username and password, username: Admin, password: DevUI.admin',
      emailContent:
        'Please input correct username and password, username: admin@devui.com, password: devuiadmin',
    },
    other: 'Sign in with',
    register: 'Sign up',
    callbackMessage: 'Github authorization callback succeeded',
  },
};
